import { Group, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { IconFigmaArrowLeft } from '@/assets/icons';
import { useRegisterMobileBack } from '@/components/layout/MobileBackContext';

interface BackButtonProps {
  /** Fallback route used only when there's no in-app history to go back to
   * (e.g. a direct/deep link load) — otherwise navigation always goes back
   * through real history, to whichever screen the user actually came from. */
  to: string;
}

export const useGoBack = (to: string) => {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(to);
    }
  };
};

/** Mala poveznica "← Natrag" iznad naslova detalj-stranice (Figma), ne gumb
 * u redu akcija — dosljedno na svakoj detalj-stranici dosegnutoj klikom na
 * redak s liste, org i admin dio aplikacije podjednako. Na mobitelu je umjesto
 * nje strelica natrag u headeru (na mjestu hamburgera). */
export const BackButton = ({ to }: BackButtonProps) => {
  const { t } = useTranslation();
  const handleBack = useGoBack(to);
  const inHeaderOnMobile = useRegisterMobileBack(to);

  return (
    <UnstyledButton
      onClick={handleBack}
      visibleFrom={inHeaderOnMobile ? 'sm' : undefined}
      style={{ display: 'inline-flex', color: 'var(--color-text-secondary)' }}
    >
      <Group gap={6} wrap="nowrap" align="center">
        <IconFigmaArrowLeft size={13} />
        <span style={{ fontSize: 13, fontWeight: 600 }}>{t('common.back')}</span>
      </Group>
    </UnstyledButton>
  );
};
